// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-table__headers-container_ba80c3d3 {
  position: relative;
}
.data-table__headers_ba80c3d3 {
  position: -webkit-sticky;
  position: sticky !important;
  top: var(--top-position, 0);
  overflow: auto;
  scrollbar-width: none;
  z-index: 21;
}
.data-table__headers_ba80c3d3::-webkit-scrollbar {
  display: none;
}
.data-table__headers_freeze_ba80c3d3:not(.without-data-table-shadow) {
  box-shadow: 0 3px 2px 0 rgba(0,0,0,0.05);
}
.data-table__headers_no-scroll_ba80c3d3 {
  overflow: hidden;
}
.data-table__headers-container_top-table + .data-table__headers_ba80c3d3 {
  z-index: 1;
}
.data-table__headers-container_top-table + .data-table__headers_ba80c3d3 .data-table__resizable-handle {
  visibility: hidden;
}
.data-table__headers-container_freeze .data-table__headers-container_right + .data-table__headers_ba80c3d3 {
  z-index: 20;
}
.data-table__headers-container_freeze + .data-table__headers_ba80c3d3 .data-table__resizable-handle {
  visibility: visible;
}
.data-table__headers-container_left + .data-table__headers_ba80c3d3 {
  overflow: unset;
}
.data-table__headers-container_left .data-table__headers-container_freeze + .data-table__headers_ba80c3d3 {
  z-index: 21;
}
.data-table__headers-container_pinned.data-table__headers-container_right + .data-table__headers_ba80c3d3 {
  z-index: 19;
}
.data-table__headers-container_right + .data-table__headers_ba80c3d3 {
  padding-right: 0.5rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"data-table__headers-container": `data-table__headers-container_ba80c3d3`,
	"data-table__headers": `data-table__headers_ba80c3d3`,
	"data-table__headers_freeze": `data-table__headers_freeze_ba80c3d3`,
	"data-table__headers_no-scroll": `data-table__headers_no-scroll_ba80c3d3`
};
export default ___CSS_LOADER_EXPORT___;
